import { Map, Record } from "immutable";

import AssigneeAggregatedStats from "seneca-common/features/assignments/features/teacher-assignments/state/models/Assignee/AggregatedStats";

import AssigneeQuestionStat from "./QuestionStat";
import AssigneeSectionStat from "./SectionStat";

export type AssigneeType = {
  status?: string;
  aggregatedStats?: AssigneeAggregatedStats;
  sectionStats?: Map<string, AssigneeSectionStat>;
  questionStats?: Map<string, AssigneeQuestionStat>;
};

export const defaultAssignee: AssigneeType = {
  status: undefined,
  aggregatedStats: undefined,
  sectionStats: Map<string, AssigneeSectionStat>(),
  questionStats: Map<string, AssigneeQuestionStat>()
};

export default class Assignee extends Record(defaultAssignee) {}
